import { api } from "./api/client.js";
import { readCookie, writeCookie } from "@bitcashier/shared/core/cookies.js";
import {
  VALUE_ASSET_COOKIE,
  parseValueAssetCookie,
  serializeValueAssetCookie,
} from "./core/balances.js";
import { showSnapshotBalances } from "./ws/marketData.svelte.js";
import { viewingAsUserId } from "./viewAsStore.js";

// The GET /ui/balances snapshot, shared between the screen that renders it (Balances) and the
// header dialog that changes its `valueAsset` (SettingsModal) — which is why it is a module-level
// store rather than screen-local state: React dispatched getBalances() into redux from the settings
// form and the balances view re-rendered off the same slice.
//
// The live per-asset amounts come over the websocket; this snapshot only supplies each asset's
// estimated value in the chosen fiat asset, plus the total account value — except while viewing the
// dashboard as another user, when there is no socket and the snapshot supplies the amounts too.

export const balanceSnapshot = $state({
  data: null,
  loading: false,
  loaded: false,
  error: null,
  // The user's chosen estimation asset, or null to let the server pick its default (EUR).
  valueAsset: parseValueAssetCookie(readCookie(VALUE_ASSET_COOKIE)),
});

export async function loadBalanceSnapshot() {
  balanceSnapshot.loading = true;
  try {
    balanceSnapshot.data = await api.get("/ui/balances", {
      clientId: true,
      params: { valueAsset: balanceSnapshot.valueAsset },
    });
    balanceSnapshot.error = null;
  } catch (error) {
    balanceSnapshot.error = error;
  } finally {
    balanceSnapshot.loading = false;
    balanceSnapshot.loaded = true;
    // No socket while viewing the dashboard as someone else, so the snapshot is the balances too —
    // settled even when it failed, or the Balances screen would wait for a frame that never comes.
    if (viewingAsUserId()) showSnapshotBalances(balanceSnapshot.data);
  }
}

// Persist the choice the way React did (same cookie, same {value,label} payload, so the React build
// still reads it during the per-env cutover) and re-request the snapshot, which is what pushes the
// new estimates onto the Balances screen.
export function setValueAsset(asset) {
  balanceSnapshot.valueAsset = asset;
  writeCookie(VALUE_ASSET_COOKIE, serializeValueAssetCookie(asset));
  return loadBalanceSnapshot();
}
